import * as React from 'react'

interface TagProps {
    title: string
}

export const Tag = ({title}: TagProps) => {
    return (
        <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-1 px-3 py-1 text-sm rounded-full bg-gray-100 text-gray-800">
                <span>{title}</span>
            </div>
        </div>
    )
}
